import { newSeasonList } from "@/mocks/anime";

export default function NewSeason() {
  return (
    <section id="new-season" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 font-bold text-sm">
              <i className="ri-flashlight-fill text-lg"></i>
              新番速递
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-900">
              本周爆笑上新，追更更方便
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              紧跟当季搞笑番热度，新鲜好笑的神番第一时间整理给你。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 text-sm font-bold text-accent-700 whitespace-nowrap">
            <span className="w-2.5 h-2.5 rounded-full bg-accent-500 animate-pulse"></span>
            每周更新中
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {newSeasonList.map((ns) => (
            <article
              key={ns.id}
              className="group bg-background-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={ns.cover}
                  alt={`${ns.title} - 小狗看番新番速递`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 rounded-full bg-secondary-500 text-foreground-900 text-xs font-bold px-2.5 py-1">
                  {ns.tag}
                </span>
                <span className="absolute top-3 right-3 rounded-full bg-background-50/95 text-foreground-800 text-xs font-bold px-2.5 py-1">
                  {ns.ep}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900">
                  {ns.title}
                </h3>
                <div className="mt-3 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1.5 text-xs text-accent-700">
                    <i className="ri-calendar-line text-sm"></i>
                    {ns.updateDay}
                  </span>
                  <span className="text-xs font-bold text-primary-600 group-hover:translate-x-0.5 transition-transform inline-flex items-center gap-1">
                    去追更
                    <i className="ri-arrow-right-s-line text-base"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}